import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";

export const POST_FILE = "POST_FILE";
export const POST_FILE_SUCCESS = "POST_FILE_SUCCESS";
export const POST_FILE_ERROR = "POST_FILE_ERROR";

export const DELETE_FIELD = "DELETE_FIELD";
export const DELETE_FIELD_SUCCESS = "DELETE_FIELD_SUCCESS";
export const DELETE_FIELD_ERROR = "DELETE_FIELD_ERROR";

// Requests

const postFile = (fetch, apiHost, data, msg, type) =>
  fetch(`${apiHost}/v1/files?type=${type}`, {
    body: data,
    method: "POST"
  }).then(response => {
    return validateResponse(response, {
      mime_type_not_allowed: {
        msg: msg.errors.wrongMimeType,
        field: "all"
      },
      file_too_large_cl: {
        msg: msg.errors.fileTooLarge,
        field: "all"
      }
    });
  });

// Actions

export function uploadFile(data) {
  let formData = new FormData();
  formData.append("file", data);

  const type = data.type === "image/jpg"
    ? "image"
    : data.type === "image/jpeg"
        ? "image"
        : data.type === "image/png"
            ? "image"
            : data.type === "image/gif"
                ? "image"
                : data.type === "image/bmp" ? "image" : "file";

  return ({ fetch, validate, config, msg }) => ({
    type: [POST_FILE],
    payload: {
      promise: postFile(
        fetch,
        config().apiHost,
        formData,
        msg().files,
        type
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: data
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/files/actions.js